// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getMessaging } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey:
    process.env.VUE_APP_FIREBASE_API_KEY ||
    "AIzaSyDtQOl0oba690X6tsFz32PxiOzr_Sn09V8",
  authDomain:
    process.env.VUE_APP_FIREBASE_AUTH_DOMAIN ||
    "chatmessages-fc29c.firebaseapp.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "chatmessages-fc29c",
  storageBucket:
    process.env.VUE_APP_FIREBASE_STORAGE_BUCKET ||
    "chatmessages-fc29c.appspot.com",
  messagingSenderId:
    process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "602129322649",
  appId:
    process.env.VUE_APP_FIREBASE_APP_ID ||
    "1:602129322649:web:1d14f26ff34dd54105de08",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firestore without offline persistence to avoid IDB clone errors
const db = getFirestore(firebaseApp);

// Initialize Firebase Cloud Messaging
// let messaging;
try {
  // messaging = getMessaging(firebaseApp);
} catch (err) {
  console.warn("Firebase Messaging is not supported in this environment:", err);
}

// Initialize App Check with ReCaptcha Enterprise
/*initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaEnterpriseProvider(
    "abcdefghijklmnopqrstuvwxy-1234567890abcd"
  ),
  isTokenAutoRefreshEnabled: true,
});*/

export default db;
